'use strict'

module.exports = {
    MORE_THAN_1000_ROWS: {
        eventId: 418,
        adapter: 'ugc-viewer',
        params: {}
    }
}